import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { elementAt } from 'rxjs/operator/elementAt';
@Directive({
  selector: '[FloatNumber]'
})
export class FloatNumberDirective {
  // Allow decimal numbers and negative values
  private maxlength:any = 11;
  private regex: RegExp; 

  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];

  constructor(private el: ElementRef, private control: NgControl) {
    if (this.el.nativeElement.maxLength != -1) {
      this.maxlength = this.el.nativeElement.maxLength;     
    }
    this.regex = new RegExp("^[-]?[0-9]{0,8}([,.][0-9]{0," + (this.maxlength - 8) + "})?$");
  }

  @HostListener('focusout', ['$event'])
  onFocusout(target: any) {
    let value = this.el.nativeElement.value;
    value = value.trim().replace(/^0+(?=\d)/, '');
    value = value.replace(',', '.');
    if (!this.isNumeric(value))
      this.control.control.setValue('');
    else
      this.control.control.setValue(value);
  }


  @HostListener('keydown', ['$event'])
  onKeyDown(event) {
    // allow copy, cut, paste
    if ((event.ctrlKey && event.key == "v") || (event.ctrlKey && event.key == "V")
      || (event.ctrlKey && event.key == "c") || (event.ctrlKey && event.key == "C")
      || (event.ctrlKey && event.key == "x") || event.ctrlKey && event.key == "X") {
      return;
    }

    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    let current: string = this.el.nativeElement.value;
    let next: string = current.concat(event.key);
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

  private isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/directives/common/float-number.direcive.ts